module.exports = {"340824100":"梅城镇","340824101":"源潭镇","340824102":"余井镇","340824103":"王河镇","340824104":"黄铺镇","340824105":"槎水镇","340824106":"水吼镇","340824107":"官庄镇","340824108":"黄泥镇","340824109":"黄柏镇","340824110":"天柱山镇","340824200":"塔畈乡","340824201":"油坝乡","340824202":"龙潭乡","340824203":"痘姆乡","340824204":"五庙乡","340824400":"开发区","340824401":"旅游度假区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340824.json
// module id = 1095
// module chunks = 0